import apiService from './api/ApiService';
import stateCacheService from './StateCache';
import alertService from './AlertService';

const MESSAGE_DELAY = 5000;

const messagesService = {
    getReadList() {
        const stateCacheInstance = stateCacheService.getStateCacheInstance();
        const messagesFromCache = stateCacheInstance.getMessages();
        return messagesFromCache?.split(',') || [];
    },

    async fetchCompareAndAlertMessages(delay) {
        const result = await apiService.fetchUnreadMessages();
        const readList = this.getReadList();
        const timeout = delay ? MESSAGE_DELAY : 0;

        if (!Array.isArray(result.hits)) {
            return;
        }

        result.hits
            .sort((a, b) => {
                const firstDate = new Date(a.timestamp);
                const secondDate = new Date(b.timestamp);
                if (firstDate > secondDate) {
                    return 1;
                } else if (firstDate < secondDate) {
                    return -1;
                }

                return 0;
            })
            .forEach((hit) => {
                if (!readList.includes(hit.id)) {
                    this.markMessageRead(hit.id);
                    this.showMessageAsAlert(hit, timeout);
                }
            });
    },

    showMessageAsAlert(hit, timeout) {
        setTimeout(() => {
            alertService.showMessage(hit);
        }, timeout);
    },

    markMessageRead(id) {
        const readList = this.getReadList();
        if (!readList.includes(id)) {
            readList.push(id);
        }
        const stateCacheInstance = stateCacheService.getStateCacheInstance();
        stateCacheInstance.setReadMessages(readList.toString());
    },
};

export default messagesService;
